import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Assessment } from '../../models/AssessmentModel';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PlatformApiService } from '../../services/platform-api.service';

@Component({
  selector: 'cw-ci-admin-assessment-edit',
  templateUrl: './assessment-edit.component.html',
  styleUrls: ['./assessment-edit.component.scss']
})
export class AdminAssessmentEditComponent implements OnInit {
  _assessment: Assessment;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  @Input() set assessment(value: Assessment) {
    this._assessment = value;
    this.assessmentForm.reset();
    if (this._assessment.id) {
      this.assessmentForm.controls.assessmentName.setValue(this._assessment.name);
      this.assessmentForm.controls.assessmentType.setValue(this._assessment.type);
      this.assessmentForm.controls.assessmentDescription.setValue(this._assessment.description);

      this._platformApi.loadAssessment(this._assessment.id).subscribe(
        resp => {
          const as = resp as Assessment;
          this.assessmentForm.controls.assessmentJson.setValue(JSON.stringify(as.json, null, 2));
        }
      );
    }

  }

  availableTypes = [
    'NIST','CERTIFICATION','PCI','HIPPA'
  ];

  assessmentForm = new FormGroup ({
    assessmentName: new FormControl('', [Validators.required]),
    assessmentType: new FormControl('', [Validators.required]),
    assessmentDescription: new FormControl('', [Validators.required]),
    assessmentJson: new FormControl('', [Validators.required]),
  });

  constructor(private _platformApi: PlatformApiService) { }

  ngOnInit() {
  }

  saveAssessment() {
    const assessmentJson = {
      name: this.assessmentForm.value.assessmentName,
      type: this.assessmentForm.value.assessmentType,
      description: this.assessmentForm.value.assessmentDescription,
      json: JSON.parse(this.assessmentForm.value.assessmentJson)
    }

    this._platformApi.saveAssessment(this._assessment.id, {assessment:assessmentJson}).subscribe(
      resp => {
        this.stateChange.emit({state: 'CREATESUCCESS'})
      }
    );
  }

  cancelAssessment() {
    this.assessmentForm.reset();
    this.stateChange.emit({state: 'EDITCANCEL'});
  }
}
